import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumEcommerceOrderOriginType implements BaseEnumType {
  private static allValues: EnumEcommerceOrderOriginType[] = []; // make sure this is top-most
  
  public static none = new EnumEcommerceOrderOriginType(0, "None", "enum_ecommerce_order_origin_type_none");
  public static shopify = new EnumEcommerceOrderOriginType(1, "Shopify", "enum_ecommerce_order_origin_type_shopify");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumEcommerceOrderOriginType.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isNone() { return this === EnumEcommerceOrderOriginType.none; }
  public isShopify() { return this === EnumEcommerceOrderOriginType.shopify; }

  public static getValues(): readonly EnumEcommerceOrderOriginType[] {
    return EnumEcommerceOrderOriginType.allValues;
  }

  public static getValuesExcept0(): readonly EnumEcommerceOrderOriginType[] {
    return EnumEcommerceOrderOriginType.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumEcommerceOrderOriginType {
    const found = EnumEcommerceOrderOriginType.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumEcommerceOrderOriginType - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumEcommerceOrderOriginType): EnumEcommerceOrderOriginType {
    const found = name ? EnumEcommerceOrderOriginType.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumEcommerceOrderOriginType - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumEcommerceOrderOriginType>): boolean {
    return this.key === other?.key;
  }
}